module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30001",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4895",
      "atom": "static-1.5252",
      "conversations-error-reporting": "static-1.9064",
      "conversations-internal-pub-sub": "static-1.16160",
      "conversations-internal-schema": "static-1.13221",
      "conversations-message-history": "static-1.13252",
      "conversations-test-sdk": "static-1.10678",
      "conversations-visitor-experience-components": "static-1.23364",
      "data-fetching-client": "static-1.9836",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5770",
      "hs-test-utils": "static-1.8199",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11652",
      "I18n": "static-7.1645",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3199",
      "jasmine-runner": "static-1.6632",
      "quartz": "static-1.7264",
      "react-dlb": "static-1.83",
      "react-select-plus": "static-1.108",
      "react-transition-group": "static-2.68",
      "redux-thunk": "static-2.43",
      "reselect": "static-3.8",
      "sanitize": "static-1.4654",
      "StyleGuideUI": "static-3.491",
      "transmute": "static-2.85",
      "urlinator": "static-1.4708",
      "usage-tracker": "static-1.7528",
      "usage-tracker-core": "static-1.7378",
      "usage-tracker-public": "static-1.7339",
      "viral-links-lib": "static-1.7248",
      "visitor-ui-component-library": "static-1.6319",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4992",
      "conversations-prop-types": "static-1.7631",
      "conversations-visitor-message-history": "static-1.22101",
      "cssUtils": "static-1.843",
      "enviro": "static-4.455",
      "flux-actions": "static-1.352",
      "foundations-components": "static-1.8278",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6396",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.189",
      "react-aria": "static-1.69",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16878",
      "react-utils": "static-2.5468",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "sanitize-text": "static-1.8322",
      "signup-constants": "static-1.19321",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5942",
      "visitor-ui-component-library-icons": "static-1.6130",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3528",
      "moment": "static-3.26",
      "quartz-config": "static-1.1042",
      "quartz-core": "static-1.6483",
      "foundations-assets": "static-1.5051",
      "foundations-theming": "static-1.4615",
      "UIComponents": "static-3.8598",
      "conversations-async-data": "static-2.7841",
      "customer-data-email": "static-1.18358",
      "cv-backend-services": "static-1.1589",
      "immutable-less": "static-1.4827",
      "conversations-skeleton-state": "static-1.7425",
      "crm-events-viz-core": "static-1.33713",
      "customer-data-objects": "static-1.7856",
      "icons": "static-2.665",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.732",
      "rpc-client-utils": "static-1.4834",
      "ui-images": "static-2.1206",
      "apollo-stack-hubspot": "static-3.89",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.85",
      "HeadJS": "static-2.777",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3310",
      "msw": "static-1.39",
      "testing-library": "static-1.155",
      "i18n-data": "static-1.225",
      "moment-timezone": "static-5.86",
      "jasmine": "static-4.4500",
      "signup-ui-url-generator": "static-2.8235",
      "HubStyle": "static-2.11959",
      "quartz-i18n": "static-1.939",
      "sassPrefix": "static-1.160",
      "bend-plugin-foundations-components": "static-1.4547",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2331",
      "hs-story-utils": "static-1.9602",
      "react-create-root-preference": "static-1.45",
      "react-virtualized": "static-2.102",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2285",
      "ui-fonts": "static-1.914",
      "hs-locale-management": "static-1.208",
      "csstype": "static-1.50",
      "quartz-head": "static-1.929",
      "quick-fetch": "static-1.4044",
      "web-vitals": "static-1.9",
      "quartz-routing": "static-1.694",
      "usage-tracker-anonymous": "static-1.5945",
      "bender-build-tools": "static-1.3308",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.852",
      "hubspotter-http": "static-1.4778",
      "mobile-manifest-mixins": "static-1.551",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.939",
      "quartz-test": "static-1.939",
      "quartz-tracking": "static-1.643",
      "trellis-components": "static-1.2304",
      "usage-tracker-container": "static-1.7518",
      "bend-plugin-foundations-theming": "static-1.3098",
      "foundations-theming-base": "static-1.3600",
      "stylex": "static-1.37",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4828",
      "customer-data-ui-utilities": "static-1.10001",
      "FileManagerCore": "static-1.39645",
      "FileManagerLib": "static-1.39786",
      "hubspot-apollo-client": "static-1.5053",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.529",
      "timezone-utils": "static-2.5420",
      "ui-gdpr-components": "static-1.10526",
      "ts-schema": "static-1.4207",
      "ai-components-ui-library": "static-1.9408",
      "avatar-components": "static-1.2675",
      "content-assistance-lib": "static-1.8025",
      "crm-component-utils": "static-1.39573",
      "crm-display-components": "static-1.25323",
      "crm-fe-perf": "static-1.23076",
      "crm-links": "static-1.6491",
      "crm-message-bus": "static-1.43491",
      "crm-search-service-types": "static-1.1331",
      "crm-source-interpretation-lib": "static-1.5509",
      "customer-data-communicator": "static-1.46039",
      "customer-data-filters-ui": "static-1.40462",
      "customer-data-objects-ui-components": "static-1.13206",
      "customer-data-properties": "static-1.52185",
      "customer-data-rte": "static-1.33442",
      "draft-plugins": "static-2.21985",
      "file-manager-components": "static-1.24146",
      "framework-data-schema-resolvers": "static-1.7071",
      "frontend-preferences-client": "static-1.8104",
      "hubspot-prosemirror": "static-1.18751",
      "object-comments-thread-lib": "static-1.11119",
      "prosemirror-user-and-team-at-mentions": "static-1.997",
      "reference-resolvers-lite": "static-1.8273",
      "ui-addon-upgrades": "static-9.18224",
      "universal-associations-select": "static-1.11241",
      "universal-record-utils-lib": "static-1.1465",
      "wootric-nps": "static-1.7110",
      "inbound-db-properties-service-client": "static-1.3973",
      "property-translator": "static-1.5570",
      "segments-query-core": "static-1.1597",
      "bend-plugin-chirp-manifest": "static-1.244",
      "chirp-fetch": "static-1.2064",
      "hub-http-shared-msw-handlers": "static-1.10402",
      "hubspotter-http-shared-msw-handlers": "static-1.10400",
      "usage-tracker-session-replay": "static-1.5214",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "trellis-theming": "static-1.1125",
      "tanstack-virtual": "static-1.33",
      "react-dnd-compat": "static-1.4791",
      "audio-components": "static-1.6180",
      "ContentUtils": "static-1.68892",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29627",
      "FileManagerImages": "static-1.37297",
      "foundations-components-legacy": "static-1.1303",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4325",
      "react-colorpicker": "static-2.10384",
      "ui-universal-auth": "static-1.9186",
      "video-components": "static-1.13866",
      "video-data-lib": "static-1.35522",
      "video-embed": "static-1.36356",
      "hubspot-apollo-cache": "static-1.512",
      "chatspot-core": "static-1.22214",
      "copilot-toolkit": "static-1.11593",
      "superstore": "static-1.4935",
      "ui-addon-video-player": "static-1.8882",
      "ui-coaching-tips": "static-1.29061",
      "card-properties-lib": "static-1.44740",
      "commerce-subscription-lib": "static-1.37591",
      "crm-actions": "static-1.6524",
      "crm-cards-sdk": "static-1.44142",
      "customer-data-properties-shared-msw-handlers": "static-1.9729",
      "customer-data-property-utils": "static-1.8272",
      "customer-data-tracking": "static-1.7062",
      "hs-resources": "static-1.355",
      "inbound-db-meta-service-client": "static-1.3715",
      "pulse": "static-1.791",
      "framework-data-table": "static-2.12325",
      "location-customization-utils-lib": "static-1.9784",
      "restore-request-side-panel-lib": "static-1.1368",
      "calling-error-reporting": "static-1.31496",
      "calling-internal-common": "static-1.31489",
      "calling-usage-tracker": "static-1.6717",
      "crm_data": "static-4.92529",
      "customer-data-content": "static-1.27624",
      "draft-content-plugins": "static-1.28709",
      "draft-convert": "static-2.76",
      "draft-extend": "static-3.79",
      "draft-js": "static-5.81",
      "draft-signature-plugin": "static-1.24507",
      "EmailSignatureEditor": "static-1.24768",
      "hubspot-prosemirror-plugins": "static-1.18743",
      "integration-settings-components": "static-1.15949",
      "integrations-lib": "static-1.16724",
      "integrations-tracking-lib": "static-1.5784",
      "native-integrations-shared-strings": "static-1.7957",
      "nav-meta": "static-1.30143",
      "onboarding-scopes": "static-1.6635",
      "outreach-assistant-email-generation": "static-1.6615",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12052",
      "quotes-client-types": "static-1.38685",
      "reference-resolvers": "static-1.8352",
      "rich-text-lib": "static-1.20138",
      "sales-email-signature-service-client": "static-1.4021",
      "sequences-lib": "static-1.8353",
      "ui-addon-i18n": "static-1.11325",
      "ui-addon-iframeable": "static-1.9252",
      "ui-business-units-lib": "static-1.9257",
      "ui-shepherd-react": "static-3.10438",
      "user-context": "static-1.5287",
      "whatsapp-sending-lib": "static-1.6391",
      "customer-data-filters-ui-msw-helpers": "static-1.22897",
      "customer-data-reference-ui-components": "static-1.13353",
      "events-data-lib": "static-1.414",
      "FormUrlGenerator": "static-2.4898",
      "framework-builder-read-service-client": "static-1.4133",
      "framework-data-schema-quick-fetch": "static-1.6976",
      "multi-account-reference-resolvers": "static-1.1160",
      "onboarding-tours": "static-1.16937",
      "reporting-datasets-permissions-lib": "static-1.14195",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21771",
      "calling-global-api": "static-1.65118",
      "calling-lifecycle-internal": "static-1.66500",
      "calling-lifecycle-messages": "static-1.58794",
      "commerce-products-lib": "static-1.10227",
      "conditional-properties-service-client": "static-1.3924",
      "crm-pipelines-api-client-types": "static-1.4265",
      "external-options-client-types": "static-1.4253",
      "formula-editor": "static-1.14571",
      "google-libphonenumber": "static-1.41",
      "inbounddb-objects-service-types": "static-1.4344",
      "meetings-icalendar-utils-lib": "static-1.809",
      "multi-currency-client-types": "static-1.3819",
      "object-builder-ui-client": "static-1.49327",
      "pipeline-validation-client-types": "static-1.4094",
      "property-value-citations": "static-1.2799",
      "smart-property-lib": "static-1.8059",
      "tiered-pricing": "static-1.1722",
      "topics-actions-lib": "static-1.326",
      "ui-addon-form-validation": "static-1.11166",
      "zustand": "static-1.74",
      "breeze-engine-lib": "static-1.1358",
      "video-components-external": "static-1.11864",
      "batch-promise": "static-1.1721",
      "fdsr-migration-layer": "static-1.190",
      "persist-promise": "static-1.3878",
      "content-media-capture": "static-1.5093",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25915",
      "knowledge-content-types": "static-1.8584",
      "payment-link-components": "static-1.23919",
      "ui-addon-emoji-picker": "static-1.10060",
      "call-summary": "static-1.39808",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10548",
      "laboratory-lib": "static-3.7328",
      "merchandise-lib": "static-1.267",
      "purchase-motions-components": "static-1.6176",
      "crm-object-search-query-utilities": "static-1.9983",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "cms-field-types": "static-1.4991",
      "content-icons-ui": "static-1.2279",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.982",
      "social-insights-client-types": "static-1.22548",
      "outpost": "static-1.4344",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5671",
      "magpie-types": "static-1.5131",
      "simple-logging-lib": "static-1.3226",
      "growth-onboarding-feedback-components": "static-1.6756",
      "customer-data-sidebar": "static-2.46506",
      "enrichment-properties-lib": "static-1.17357",
      "ui-addon-draggable-compat": "static-2.4435",
      "commerce-billing-lib": "static-1.19696",
      "commerce-shared-components-lib": "static-1.18985",
      "commerce-tools-ui-lib": "static-1.10836",
      "event-emitter": "static-1.1127",
      "bend-plugin-pulse": "static-1.294",
      "fast-json-patch": "static-1.66",
      "customer-data-associations": "static-1.7509",
      "reporting-data": "static-1.68254",
      "ui-addon-draggable": "static-3.4934",
      "crm-record-cards-service-types": "static-1.3712",
      "crm_universal": "static-1.22324",
      "SalesContentIndexUI": "static-3.9490",
      "content-embed-lib": "static-1.7513",
      "data-model-builder-lib": "static-1.12858",
      "remote-ui": "static-1.68",
      "ui-components-test-utils": "static-1.5789",
      "ui-extensions-remote-renderer": "static-1.17554",
      "universal-page-editor-lib": "static-1.3189",
      "integrations-error-boundary-lib": "static-1.14139",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10541",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.700",
      "messaging-types-lib": "static-1.46586",
      "ai-addon-copilot-preview": "static-1.8620",
      "copilot-plugins": "static-1.11566",
      "data-token-picker": "static-1.16720",
      "sequences-client-types-lib": "static-1.8210",
      "foundations-components-test-utils": "static-1.5761",
      "navigation-messaging": "static-1.7833",
      "getting-started-shared-tasks": "static-1.18941",
      "getting-started-shared-tasks-store": "static-1.18059",
      "onboarding-tours-utils": "static-1.1003",
      "messaging-usage-based-billing-components-lib": "static-1.1711",
      "whatsapp-management-lib": "static-1.9550",
      "growth-data-modal": "static-1.5719",
      "growth-onboarding-confetti": "static-1.3239",
      "growth-onboarding-next-action-utils": "static-1.2442",
      "navigation-components": "static-1.18506",
      "onboarding-tours-client": "static-1.5151",
      "ui-shepherd-tracker": "static-1.7819",
      "shared-worker-versioning": "static-1.11213",
      "voice-sms-access-library": "static-1.1635",
      "commerce-permissions": "static-1.952",
      "products-iframe-lib": "static-1.8363",
      "products-ui-components-shared-msw-handlers": "static-1.10784",
      "bark-lib": "static-1.16663",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.98",
      "crm-properties-common-lib": "static-1.6064",
      "react-codemirror": "static-1.10810",
      "data-agent-kit": "static-1.474",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10485",
      "fsm": "static-1.3906",
      "policy-lib": "static-1.6961",
      "react-tinymce": "static-1.55720",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54846",
      "tinymce-plugins": "static-1.57960",
      "tinymce-themes": "static-1.56816",
      "breeze-engine-core": "static-1.636",
      "highlight.js": "static-1.82",
      "content-media-composition-data-lib": "static-1.12897",
      "content-media-compositions": "static-2.16904",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19235",
      "fix-webm-duration": "static-1.26",
      "notification-sounds": "static-1.4602",
      "seat-types-lib": "static-1.408",
      "ui-addon-opt": "static-4.8537",
      "commerce-tours-lib": "static-1.6435",
      "growth-onboarding-reliability": "static-1.5259",
      "sales-checkout-service-client": "static-1.3743",
      "calling-cross-tab-library": "static-1.19465",
      "calling-lifecycle-usage-tracker": "static-1.9169",
      "purchase-motions-api": "static-1.6179",
      "reactive-lib": "static-1.901",
      "card-payment-highlight-lib": "static-1.37701",
      "card-subscription-highlight-lib": "static-1.40014",
      "commerce-contract-lib": "static-1.12900",
      "invoices-highlight-card-lib": "static-1.55315",
      "orders-highlight-card-lib": "static-1.21961",
      "products-highlight-card-lib": "static-1.18510",
      "quotes-highlight-card-lib": "static-1.72595",
      "usage-based-billing-components-lib": "static-1.9720",
      "utility-belt": "static-1.2709",
      "payments-enrollment-embed-lib": "static-1.23532",
      "stripe-embedded-components": "static-1.7824",
      "growth-onboarding-empty-states": "static-1.6082",
      "InboxConnectUtils": "static-4.15297",
      "payments-post-enroll-local-storage-lib": "static-1.5280",
      "qrcode-generator": "static-1.72",
      "reporting-client-types": "static-1.2604",
      "react-flip-move": "static-1.74",
      "FireAlarmUi": "static-1.4635",
      "sales-templates-service-types-lib": "static-1.4296",
      "ui-asset-management-lib": "static-1.11258",
      "association-settings-lib": "static-1.10772",
      "collaboration-sidebar": "static-1.58417",
      "conditional-property-settings-modal": "static-1.12837",
      "data-model-commons-lib": "static-1.13129",
      "ExportDialog": "static-6.10555",
      "final-form": "static-1.73",
      "nudge-client-utils": "static-1.2957",
      "object-definition-builder-lib": "static-1.7283",
      "property-management-iframe": "static-1.13782",
      "property-usages-lib": "static-1.5628",
      "reactflow": "static-1.67",
      "simple-data-table": "static-1.3286",
      "used-in-list-lib": "static-1.7138",
      "visual-association": "static-1.6067",
      "highcharts": "static-8.107",
      "reporting-visualizations": "static-1.60330",
      "ui-extensibility-client-types": "static-1.4098",
      "adobe-sign-auth-lib": "static-1.204",
      "ads-unified-auth-lib": "static-1.695",
      "google-sheets-integration-lib": "static-1.769",
      "microsoft-drive-integration-lib": "static-1.878",
      "surveymonkey-integration-lib": "static-1.219",
      "slack-ui-library": "static-1.10574",
      "automation-platform-service-types": "static-1.2632",
      "ContentData": "static-1.68967",
      "email-portal-health-service-types": "static-1.1153",
      "marketing-email-service-types": "static-1.2029",
      "ai-rendering-library": "static-1.10802",
      "ai-settings-ui-library": "static-1.8159",
      "ui-brand-identity-lib": "static-1.15939",
      "messaging-shared-utils-lib": "static-1.1160",
      "messaging-user-info-utils-lib": "static-1.1330",
      "content-whatsapp-service-types": "static-1.499",
      "marketing-platform-lib": "static-1.7044",
      "short-messages-app-service-client": "static-1.4096",
      "ui-tool-access": "static-1.10329",
      "onboarding-data-sync-lib": "static-1.2266",
      "growth-onboarding-next-action-components": "static-1.2470",
      "user-context-client": "static-1.4727",
      "nest": "static-1.412",
      "calling-orchestration-schema": "static-1.36412",
      "sales-views-client-types": "static-1.4435",
      "react-reducer-toolkit": "static-1.16094",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4683",
      "storybook-react": "static-1.36",
      "hub-http-contrib": "static-1.3219",
      "interframe": "static-3.4932",
      "tinymce-data": "static-1.40931",
      "ui-addon-sales-email": "static-1.5389",
      "layout-dnd-components": "static-1.12787",
      "layout-dnd-utils": "static-1.11762",
      "NamespacedHubStyle": "static-2.9178",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40745",
      "accounting-integrations-ui-components": "static-1.7357",
      "invoices-ui-lib": "static-1.55331",
      "commerce-products-api": "static-1.2553",
      "invoices-iframe-lib": "static-1.57389",
      "quotes-modal-lib": "static-1.103273",
      "quotes-ui-lib": "static-1.81316",
      "platform-infra-nav-components": "static-1.7801",
      "reporting-ui-components": "static-2.65525",
      "subscription-experience-data-types": "static-1.15133",
      "marketplace-ui-apps-core": "static-1.18874",
      "stripe-connect-js": "static-1.72",
      "ui-addon-react-router-dom": "static-1.9711",
      "nested-table": "static-1.413",
      "chatspot-widget-iframe": "static-1.22205",
      "collaboration-sidebar-common": "static-1.3214",
      "nudge-custom-function-registry": "static-1.2714",
      "nudge-renderer-utils": "static-1.3033",
      "whisper-core-api": "static-1.7060",
      "property-management-common": "static-1.6070",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15421",
      "advanced-menus-lib": "static-1.12316",
      "ui-memberships-settings-lib": "static-1.34536",
      "breeze-onboarding-components": "static-1.455",
      "embedded-academy-lib": "static-1.15010",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.41762",
      "reporting-snowflake": "static-1.56872",
      "meetings-connect-utils-lib": "static-1.7783",
      "layout-data-lib": "static-1.10087",
      "commerce-tax-lib": "static-1.714",
      "price-books-api": "static-1.1441",
      "price-books-components": "static-1.1499",
      "property-description-translator": "static-1.4014",
      "ramp-editor": "static-1.656",
      "commerce-analytics-service-client": "static-1.3731",
      "totals-ui-components": "static-1.24077",
      "reporting-plugins": "static-1.10615",
      "reporting-reports": "static-1.67932",
      "edison-service-client-types": "static-1.563",
      "developer-experience-shared-components": "static-1.10707",
      "marketplace-ui-client-types": "static-1.17749",
      "marketplace-ui-common": "static-1.20342",
      "ui-addon-integrations-directory-panel": "static-2.8199",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.349",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15420",
      "simple-menus-lib": "static-1.16937",
      "onboarding-journeys-lib": "static-1.555",
      "academy-common-lib": "static-1.14470",
      "dashboard-lib": "static-1.82247",
      "share-with-third-party-component-lib": "static-1.8882",
      "line-items-api": "static-1.950",
      "commerce-totals-service-types": "static-1.3943",
      "campaign-roi-lib": "static-1.9741",
      "ui-addon-calendars": "static-2.5499",
      "apps-service-types": "static-1.3973",
      "oauth-service-types": "static-1.4431",
      "ui-product-approvals-common": "static-1.711",
      "academy-service-client": "static-1.3863",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4578",
      "trellis-ecosystem": "static-1.7453",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30001",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4895",
      "atom": "/atom/static-1.5252",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9064",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16160",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13221",
      "conversations-message-history": "/conversations-message-history/static-1.13252",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10678",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.23364",
      "data-fetching-client": "/data-fetching-client/static-1.9836",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5770",
      "hs-test-utils": "/hs-test-utils/static-1.8199",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11652",
      "I18n": "/I18n/static-7.1645",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3199",
      "jasmine-runner": "/jasmine-runner/static-1.6632",
      "quartz": "/quartz/static-1.7264",
      "react-dlb": "/react-dlb/static-1.83",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-transition-group": "/react-transition-group/static-2.68",
      "redux-thunk": "/redux-thunk/static-2.43",
      "reselect": "/reselect/static-3.8",
      "sanitize": "/sanitize/static-1.4654",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4708",
      "usage-tracker": "/usage-tracker/static-1.7528",
      "usage-tracker-core": "/usage-tracker-core/static-1.7378",
      "usage-tracker-public": "/usage-tracker-public/static-1.7339",
      "viral-links-lib": "/viral-links-lib/static-1.7248",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6319",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4992",
      "conversations-prop-types": "/conversations-prop-types/static-1.7631",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22101",
      "cssUtils": "/cssUtils/static-1.843",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.352",
      "foundations-components": "/foundations-components/static-1.8278",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6396",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.189",
      "react-aria": "/react-aria/static-1.69",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16878",
      "react-utils": "/react-utils/static-2.5468",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "sanitize-text": "/sanitize-text/static-1.8322",
      "signup-constants": "/signup-constants/static-1.19321",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5942",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6130",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3528",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.1042",
      "quartz-core": "/quartz-core/static-1.6483",
      "foundations-assets": "/foundations-assets/static-1.5051",
      "foundations-theming": "/foundations-theming/static-1.4615",
      "UIComponents": "/UIComponents/static-3.8598",
      "conversations-async-data": "/conversations-async-data/static-2.7841",
      "customer-data-email": "/customer-data-email/static-1.18358",
      "cv-backend-services": "/cv-backend-services/static-1.1589",
      "immutable-less": "/immutable-less/static-1.4827",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7425",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33713",
      "customer-data-objects": "/customer-data-objects/static-1.7856",
      "icons": "/icons/static-2.665",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.732",
      "rpc-client-utils": "/rpc-client-utils/static-1.4834",
      "ui-images": "/ui-images/static-2.1206",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.85",
      "HeadJS": "/HeadJS/static-2.777",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3310",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.155",
      "i18n-data": "/i18n-data/static-1.225",
      "moment-timezone": "/moment-timezone/static-5.86",
      "jasmine": "/jasmine/static-4.4500",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8235",
      "HubStyle": "/HubStyle/static-2.11959",
      "quartz-i18n": "/quartz-i18n/static-1.939",
      "sassPrefix": "/sassPrefix/static-1.160",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4547",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2331",
      "hs-story-utils": "/hs-story-utils/static-1.9602",
      "react-create-root-preference": "/react-create-root-preference/static-1.45",
      "react-virtualized": "/react-virtualized/static-2.102",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2285",
      "ui-fonts": "/ui-fonts/static-1.914",
      "hs-locale-management": "/hs-locale-management/static-1.208",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.929",
      "quick-fetch": "/quick-fetch/static-1.4044",
      "web-vitals": "/web-vitals/static-1.9",
      "quartz-routing": "/quartz-routing/static-1.694",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5945",
      "bender-build-tools": "/bender-build-tools/static-1.3308",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.852",
      "hubspotter-http": "/hubspotter-http/static-1.4778",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.939",
      "quartz-test": "/quartz-test/static-1.939",
      "quartz-tracking": "/quartz-tracking/static-1.643",
      "trellis-components": "/trellis-components/static-1.2304",
      "usage-tracker-container": "/usage-tracker-container/static-1.7518",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3098",
      "foundations-theming-base": "/foundations-theming-base/static-1.3600",
      "stylex": "/stylex/static-1.37",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4828",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10001",
      "FileManagerCore": "/FileManagerCore/static-1.39645",
      "FileManagerLib": "/FileManagerLib/static-1.39786",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5053",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.529",
      "timezone-utils": "/timezone-utils/static-2.5420",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10526",
      "ts-schema": "/ts-schema/static-1.4207",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9408",
      "avatar-components": "/avatar-components/static-1.2675",
      "content-assistance-lib": "/content-assistance-lib/static-1.8025",
      "crm-component-utils": "/crm-component-utils/static-1.39573",
      "crm-display-components": "/crm-display-components/static-1.25323",
      "crm-fe-perf": "/crm-fe-perf/static-1.23076",
      "crm-links": "/crm-links/static-1.6491",
      "crm-message-bus": "/crm-message-bus/static-1.43491",
      "crm-search-service-types": "/crm-search-service-types/static-1.1331",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5509",
      "customer-data-communicator": "/customer-data-communicator/static-1.46039",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40462",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13206",
      "customer-data-properties": "/customer-data-properties/static-1.52185",
      "customer-data-rte": "/customer-data-rte/static-1.33442",
      "draft-plugins": "/draft-plugins/static-2.21985",
      "file-manager-components": "/file-manager-components/static-1.24146",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7071",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8104",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18751",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11119",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.997",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8273",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18224",
      "universal-associations-select": "/universal-associations-select/static-1.11241",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1465",
      "wootric-nps": "/wootric-nps/static-1.7110",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3973",
      "property-translator": "/property-translator/static-1.5570",
      "segments-query-core": "/segments-query-core/static-1.1597",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.244",
      "chirp-fetch": "/chirp-fetch/static-1.2064",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10402",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10400",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5214",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "trellis-theming": "/trellis-theming/static-1.1125",
      "tanstack-virtual": "/tanstack-virtual/static-1.33",
      "react-dnd-compat": "/react-dnd-compat/static-1.4791",
      "audio-components": "/audio-components/static-1.6180",
      "ContentUtils": "/ContentUtils/static-1.68892",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29627",
      "FileManagerImages": "/FileManagerImages/static-1.37297",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1303",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4325",
      "react-colorpicker": "/react-colorpicker/static-2.10384",
      "ui-universal-auth": "/ui-universal-auth/static-1.9186",
      "video-components": "/video-components/static-1.13866",
      "video-data-lib": "/video-data-lib/static-1.35522",
      "video-embed": "/video-embed/static-1.36356",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.512",
      "chatspot-core": "/chatspot-core/static-1.22214",
      "copilot-toolkit": "/copilot-toolkit/static-1.11593",
      "superstore": "/superstore/static-1.4935",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8882",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29061",
      "card-properties-lib": "/card-properties-lib/static-1.44740",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37591",
      "crm-actions": "/crm-actions/static-1.6524",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44142",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9729",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8272",
      "customer-data-tracking": "/customer-data-tracking/static-1.7062",
      "hs-resources": "/hs-resources/static-1.355",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3715",
      "pulse": "/pulse/static-1.791",
      "framework-data-table": "/framework-data-table/static-2.12325",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9784",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1368",
      "calling-error-reporting": "/calling-error-reporting/static-1.31496",
      "calling-internal-common": "/calling-internal-common/static-1.31489",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6717",
      "crm_data": "/crm_data/static-4.92529",
      "customer-data-content": "/customer-data-content/static-1.27624",
      "draft-content-plugins": "/draft-content-plugins/static-1.28709",
      "draft-convert": "/draft-convert/static-2.76",
      "draft-extend": "/draft-extend/static-3.79",
      "draft-js": "/draft-js/static-5.81",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24507",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24768",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18743",
      "integration-settings-components": "/integration-settings-components/static-1.15949",
      "integrations-lib": "/integrations-lib/static-1.16724",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5784",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7957",
      "nav-meta": "/nav-meta/static-1.30143",
      "onboarding-scopes": "/onboarding-scopes/static-1.6635",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6615",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12052",
      "quotes-client-types": "/quotes-client-types/static-1.38685",
      "reference-resolvers": "/reference-resolvers/static-1.8352",
      "rich-text-lib": "/rich-text-lib/static-1.20138",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4021",
      "sequences-lib": "/sequences-lib/static-1.8353",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11325",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9252",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9257",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10438",
      "user-context": "/user-context/static-1.5287",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6391",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22897",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13353",
      "events-data-lib": "/events-data-lib/static-1.414",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4898",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4133",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6976",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1160",
      "onboarding-tours": "/onboarding-tours/static-1.16937",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14195",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21771",
      "calling-global-api": "/calling-global-api/static-1.65118",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66500",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58794",
      "commerce-products-lib": "/commerce-products-lib/static-1.10227",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3924",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4265",
      "external-options-client-types": "/external-options-client-types/static-1.4253",
      "formula-editor": "/formula-editor/static-1.14571",
      "google-libphonenumber": "/google-libphonenumber/static-1.41",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4344",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.809",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3819",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49327",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4094",
      "property-value-citations": "/property-value-citations/static-1.2799",
      "smart-property-lib": "/smart-property-lib/static-1.8059",
      "tiered-pricing": "/tiered-pricing/static-1.1722",
      "topics-actions-lib": "/topics-actions-lib/static-1.326",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11166",
      "zustand": "/zustand/static-1.74",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1358",
      "video-components-external": "/video-components-external/static-1.11864",
      "batch-promise": "/batch-promise/static-1.1721",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.190",
      "persist-promise": "/persist-promise/static-1.3878",
      "content-media-capture": "/content-media-capture/static-1.5093",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25915",
      "knowledge-content-types": "/knowledge-content-types/static-1.8584",
      "payment-link-components": "/payment-link-components/static-1.23919",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10060",
      "call-summary": "/call-summary/static-1.39808",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10548",
      "laboratory-lib": "/laboratory-lib/static-3.7328",
      "merchandise-lib": "/merchandise-lib/static-1.267",
      "purchase-motions-components": "/purchase-motions-components/static-1.6176",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9983",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "cms-field-types": "/cms-field-types/static-1.4991",
      "content-icons-ui": "/content-icons-ui/static-1.2279",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.982",
      "social-insights-client-types": "/social-insights-client-types/static-1.22548",
      "outpost": "/outpost/static-1.4344",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5671",
      "magpie-types": "/magpie-types/static-1.5131",
      "simple-logging-lib": "/simple-logging-lib/static-1.3226",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6756",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46506",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17357",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4435",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19696",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18985",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10836",
      "event-emitter": "/event-emitter/static-1.1127",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.294",
      "fast-json-patch": "/fast-json-patch/static-1.66",
      "customer-data-associations": "/customer-data-associations/static-1.7509",
      "reporting-data": "/reporting-data/static-1.68254",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4934",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3712",
      "crm_universal": "/crm_universal/static-1.22324",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9490",
      "content-embed-lib": "/content-embed-lib/static-1.7513",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12858",
      "remote-ui": "/remote-ui/static-1.68",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5789",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17554",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3189",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14139",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10541",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.700",
      "messaging-types-lib": "/messaging-types-lib/static-1.46586",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8620",
      "copilot-plugins": "/copilot-plugins/static-1.11566",
      "data-token-picker": "/data-token-picker/static-1.16720",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8210",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5761",
      "navigation-messaging": "/navigation-messaging/static-1.7833",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18941",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18059",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1003",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1711",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9550",
      "growth-data-modal": "/growth-data-modal/static-1.5719",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3239",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2442",
      "navigation-components": "/navigation-components/static-1.18506",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5151",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7819",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11213",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1635",
      "commerce-permissions": "/commerce-permissions/static-1.952",
      "products-iframe-lib": "/products-iframe-lib/static-1.8363",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10784",
      "bark-lib": "/bark-lib/static-1.16663",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.98",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6064",
      "react-codemirror": "/react-codemirror/static-1.10810",
      "data-agent-kit": "/data-agent-kit/static-1.474",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10485",
      "fsm": "/fsm/static-1.3906",
      "policy-lib": "/policy-lib/static-1.6961",
      "react-tinymce": "/react-tinymce/static-1.55720",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54846",
      "tinymce-plugins": "/tinymce-plugins/static-1.57960",
      "tinymce-themes": "/tinymce-themes/static-1.56816",
      "breeze-engine-core": "/breeze-engine-core/static-1.636",
      "highlight.js": "/highlight.js/static-1.82",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12897",
      "content-media-compositions": "/content-media-compositions/static-2.16904",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19235",
      "fix-webm-duration": "/fix-webm-duration/static-1.26",
      "notification-sounds": "/notification-sounds/static-1.4602",
      "seat-types-lib": "/seat-types-lib/static-1.408",
      "ui-addon-opt": "/ui-addon-opt/static-4.8537",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6435",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5259",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19465",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9169",
      "purchase-motions-api": "/purchase-motions-api/static-1.6179",
      "reactive-lib": "/reactive-lib/static-1.901",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37701",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40014",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12900",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55315",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21961",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18510",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72595",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9720",
      "utility-belt": "/utility-belt/static-1.2709",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23532",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7824",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6082",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15297",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5280",
      "qrcode-generator": "/qrcode-generator/static-1.72",
      "reporting-client-types": "/reporting-client-types/static-1.2604",
      "react-flip-move": "/react-flip-move/static-1.74",
      "FireAlarmUi": "/FireAlarmUi/static-1.4635",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4296",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11258",
      "association-settings-lib": "/association-settings-lib/static-1.10772",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58417",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12837",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13129",
      "ExportDialog": "/ExportDialog/static-6.10555",
      "final-form": "/final-form/static-1.73",
      "nudge-client-utils": "/nudge-client-utils/static-1.2957",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7283",
      "property-management-iframe": "/property-management-iframe/static-1.13782",
      "property-usages-lib": "/property-usages-lib/static-1.5628",
      "reactflow": "/reactflow/static-1.67",
      "simple-data-table": "/simple-data-table/static-1.3286",
      "used-in-list-lib": "/used-in-list-lib/static-1.7138",
      "visual-association": "/visual-association/static-1.6067",
      "highcharts": "/highcharts/static-8.107",
      "reporting-visualizations": "/reporting-visualizations/static-1.60330",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4098",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.204",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.695",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.769",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.219",
      "slack-ui-library": "/slack-ui-library/static-1.10574",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
      "ContentData": "/ContentData/static-1.68967",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1153",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2029",
      "ai-rendering-library": "/ai-rendering-library/static-1.10802",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8159",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15939",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1160",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1330",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.499",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7044",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4096",
      "ui-tool-access": "/ui-tool-access/static-1.10329",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2266",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2470",
      "user-context-client": "/user-context-client/static-1.4727",
      "nest": "/nest/static-1.412",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36412",
      "sales-views-client-types": "/sales-views-client-types/static-1.4435",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16094",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4683",
      "storybook-react": "/storybook-react/static-1.36",
      "hub-http-contrib": "/hub-http-contrib/static-1.3219",
      "interframe": "/interframe/static-3.4932",
      "tinymce-data": "/tinymce-data/static-1.40931",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5389",
      "layout-dnd-components": "/layout-dnd-components/static-1.12787",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11762",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9178",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40745",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7357",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55331",
      "commerce-products-api": "/commerce-products-api/static-1.2553",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57389",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103273",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81316",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7801",
      "reporting-ui-components": "/reporting-ui-components/static-2.65525",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15133",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18874",
      "stripe-connect-js": "/stripe-connect-js/static-1.72",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9711",
      "nested-table": "/nested-table/static-1.413",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22205",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3214",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2714",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3033",
      "whisper-core-api": "/whisper-core-api/static-1.7060",
      "property-management-common": "/property-management-common/static-1.6070",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15421",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12316",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34536",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.455",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15010",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.41762",
      "reporting-snowflake": "/reporting-snowflake/static-1.56872",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7783",
      "layout-data-lib": "/layout-data-lib/static-1.10087",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.714",
      "price-books-api": "/price-books-api/static-1.1441",
      "price-books-components": "/price-books-components/static-1.1499",
      "property-description-translator": "/property-description-translator/static-1.4014",
      "ramp-editor": "/ramp-editor/static-1.656",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3731",
      "totals-ui-components": "/totals-ui-components/static-1.24077",
      "reporting-plugins": "/reporting-plugins/static-1.10615",
      "reporting-reports": "/reporting-reports/static-1.67932",
      "edison-service-client-types": "/edison-service-client-types/static-1.563",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10707",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17749",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20342",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8199",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.349",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15420",
      "simple-menus-lib": "/simple-menus-lib/static-1.16937",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.555",
      "academy-common-lib": "/academy-common-lib/static-1.14470",
      "dashboard-lib": "/dashboard-lib/static-1.82247",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8882",
      "line-items-api": "/line-items-api/static-1.950",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3943",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9741",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5499",
      "apps-service-types": "/apps-service-types/static-1.3973",
      "oauth-service-types": "/oauth-service-types/static-1.4431",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.711",
      "academy-service-client": "/academy-service-client/static-1.3863",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4578",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7453",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30001",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};